import React, { useState, useEffect, useCallback } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../config.js';
import { jwtDecode } from 'jwt-decode';
import api from '../../api/api.js';

import {
  Bell,
  DollarSign,
  Eye,
  HardHat,
  Heart,
  MessageSquare,
  Search,
  Settings,
  Star,
  TrendingUp,
  Users,
  Wrench,
} from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "../../_newprofiles/components/ui/Avatar.jsx";
import { Badge } from "../../_newprofiles/components/ui/Badge.jsx";
import { Button } from "../../_newprofiles/components/ui/Button.jsx";
import { Card, CardContent, CardHeader, CardTitle } from "../../_newprofiles/components/ui/Card.jsx";
import { Progress } from "../../_newprofiles/components/ui/Progress.jsx";
import styles from "./_BusinessDashboard.module.css";
import NavbarLogout from "../../components/Navbar/navbar-logout.js";
import ModernNavbarPureCSS from "../../components/Navbar/ModernNavBarPureCSS.jsx";
import SearchFormComponent from "./SearchFormComponent.jsx";
import imageLogo from "../../assets/images/LogoBuildStart03.png";
import ImportGoogleRatingModal from '../../components/Google/ImportGoogleRatingModal.jsx';
import { User } from "lucide-react";

const BusinessDashboardPureCSS = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [businessUserId, setBusinessUserId] = useState(null);
  const [isOnboardingComplete, setIsOnboardingComplete] = useState(false);
  const [savedBusinessesData, setSavedBusinessesData] = useState([]);
  const [isLoadingSavedBusinesses, setIsLoadingSavedBusinesses] = useState(false);
  const [savedBusinessesError, setSavedBusinessesError] = useState(null);
  const [jobLeads, setJobLeads] = useState([]);
  const [isLoadingJobLeads, setIsLoadingJobLeads] = useState(false);
  const [jobLeadsError, setJobLeadsError] = useState(null);
  const [myuserType, setMyUserType] = useState(localStorage.getItem('userType'));
  const [loggedInBusinessId, setLoggedInBusinessId] = useState(localStorage.getItem('loggedInBusinessId'));
  const [businessProfile, setBusinessProfile] = useState(null);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false);

  const [isGoogleModalOpen, setIsGoogleModalOpen] = useState(false);


  const [recentMessages, setRecentMessages] = useState([]);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [messagesError, setMessagesError] = useState(null);



    useEffect(() => {


        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                //console.log("Decoded Token:", decodedToken);
                setUsername(decodedToken.UserName || 'User');
                setBusinessUserId(decodedToken.nameid);

                const myuserType = decodedToken.UserType;

                const shouldOnboard = localStorage.getItem('shouldOnboard');
                //console.log(`dashboard shouldOnboard = ${shouldOnboard}`);

                if (shouldOnboard === 'true') {
                    //console.log(`NAVIGATE TO ONBOARDING`);
                    navigate('/business-onboarding-new');
                } else {
                    //console.log(`STAY ON dashboard `);
                    setIsOnboardingComplete(true);
                }

            } catch (error) {
                console.error("Error decoding token:", error);
                navigate('/login');
            }
        } else {
            navigate('/login');
        }
    }, [navigate]);

    useEffect(() => {
      if (loggedInBusinessId) {
        const fetchJobLeads = async () => {
          setIsLoadingJobLeads(true);
          setJobLeadsError(null);
          try {
            const response = await axios.get(
              `${API_BASE_URL}/api/Jobs/getMyJobsForBusiness?businessId=${loggedInBusinessId}`
            );
            setJobLeads(response.data || []);
          } catch (err) {
            console.error("Error fetching job leads:", err);
            setJobLeadsError(err.message || "Failed to fetch job leads.");
            setJobLeads([]);
          } finally {
            setIsLoadingJobLeads(false);
          }
        };
        fetchJobLeads();
      }

      if (businessUserId) {
        const fetchSavedBusinesses = async () => {
          setIsLoadingSavedBusinesses(true);
          setSavedBusinessesError(null);
          try {
            const response = await axios.get(
              `${API_BASE_URL}/api/BusinessProfile/getSavedBusinesses?userType=Business&userId=${businessUserId}`
            );
            setSavedBusinessesData(response.data || []);
          } catch (err) {
            console.error("Error fetching saved businesses:", err);
            setSavedBusinessesError(err.message || "Failed to fetch saved businesses.");
            setSavedBusinessesData([]);
          } finally {
            setIsLoadingSavedBusinesses(false);
          }
        };
        fetchSavedBusinesses();
      }
    }, [loggedInBusinessId, businessUserId]);

    useEffect(() => {
        if (loggedInBusinessId) {
            const fetchBusinessProfile = async () => {
                setIsLoadingProfile(true);
                try {
                    const response = await axios.get(`${API_BASE_URL}/api/BusinessProfile/getBusinessProfile?businessId=${loggedInBusinessId}&logView=false&ommitProfilePic=true`);
                    
                    setBusinessProfile(response.data);

                    //console.log(response.data);

                } catch (error) {
                    console.error("Error fetching business profile:", error);
                } finally {
                    setIsLoadingProfile(false);
                }
            };
            fetchBusinessProfile();
        }
    }, [loggedInBusinessId]);



    // --- USEEFFECT TO FETCH MESSAGES ---
    useEffect(() => {
        const fetchRecentMessages = async () => {
            setIsLoadingMessages(true);
            setMessagesError(null);
            try {
                // Use your configured 'api' instance which includes the auth token
                const response = await api.get('/api/Chat/getRecentMessages');
                setRecentMessages(response.data || []); // The backend returns data directly on the api instance
            } catch (err) {
                console.error("Error fetching recent messages:", err);
                setMessagesError("Failed to load messages.");
                setRecentMessages([]);
            } finally {
                setIsLoadingMessages(false);
            }
        };

        if (isOnboardingComplete) { // Only fetch if onboarding is done
            fetchRecentMessages();
        }
    }, [isOnboardingComplete]);


  // --- HELPER FUNCTION ---
  const timeSince = (date) => {
      const seconds = Math.floor((new Date() - new Date(date)) / 1000);
      let interval = seconds / 31536000;
      if (interval > 1) return Math.floor(interval) + " years ago";
      interval = seconds / 2592000;
      if (interval > 1) return Math.floor(interval) + " months ago";
      interval = seconds / 86400;
      if (interval > 1) return Math.floor(interval) + " days ago";
      interval = seconds / 3600;
      if (interval > 1) return Math.floor(interval) + " hours ago";
      interval = seconds / 60;
      if (interval > 1) return Math.floor(interval) + " minutes ago";
      return "Just now";
  };


    const handleEditProfile = () => {
        const userType = localStorage.getItem('userType');
        if (userType === 'Business') {
            const businessId = localStorage.getItem('loggedInBusinessId');
            navigate(`/business-onboarding-new/${businessId}`);
        } else {
            const loggedInHomeUserId = localStorage.getItem('loggedInHomeUserId');
            navigate(`/home-user-profile/${loggedInHomeUserId}`);
        }
    };



      const fetchBusinessProfile = async () => {
        // Encapsulate fetch logic so we can call it again
        setIsLoadingProfile(true);
        try {
            const response = await api.get(`/api/BusinessProfile/getBusinessProfile?businessId=${loggedInBusinessId}&logView=false&ommitProfilePic=true`);
            setBusinessProfile(response.data); // 'api' instance returns data directly
        } catch (error) {
            console.error("Error fetching business profile:", error);
        } finally {
            setIsLoadingProfile(false);
        }
    };

    useEffect(() => {
        if (loggedInBusinessId) {
            fetchBusinessProfile();
        }
    }, [loggedInBusinessId]);



    // --- 3. CREATE A SUCCESS HANDLER ---
    // This function will be passed to the modal
    const handleImportSuccess = () => {
        // Re-fetch the profile data to show the updated rating on the dashboard
        fetchBusinessProfile();
    };






  const getFirstName = (name) => {
    if (!name || name.toLowerCase() === 'user') return 'User';
    return name.split(' ')[0];
  };

  const isUrgent = (deadline) => {
    return deadline && deadline.toLowerCase() === 'urgently';
  }


  if (!isOnboardingComplete) {
    return (
      <div className={styles.dashboardContainer}>
        <header className={styles.header}>
          <div className={`${styles.container} ${styles.headerContainerFluid}`}>
            <div className={styles.headerContent}>
              <div className={styles.headerLeft}>
                <div className={styles.logoContainer}>
                  <HardHat className={styles.logoIcon} />
                  <span className={styles.logoText}>Build Start</span>
                </div>
              </div>
            </div>
            <ModernNavbarPureCSS UserName={username} prefix={''} TabActiveId={'home'} />
          </div>
        </header>

      <div className={`${styles.container} ${styles.mainContent}`}> {/* Assuming container handles mx-auto */}
        <div className={styles.welcomeSection}>
          <h1 className={styles.welcomeTitle}>Welcome back, {getFirstName(username)}! 👷‍♂️</h1>
          <p className={styles.welcomeSubtitle}>Onboarding is required before continuing. Please log out and log back in.</p>
        </div>
      </div>


        {/* Optionally, show a loader or a message while redirecting */}
      </div>
    );
  }

  return (
    <div className={styles.dashboardContainer}>
      {/* Header */}
      <header className={styles.header}>
        <div className={`${styles.container} ${styles.headerContainerFluid}`}> {/* Assuming container handles mx-auto */}
          <div className={styles.headerContent}>
            <div className={styles.headerLeft}>
              <div className={styles.logoContainer}>
                          <img
            src={imageLogo}   // Replace with your logo image path
            alt="Build Start Logo"
            style={{ height: '35px', marginRight: '10px' }}  // Adjust size & spacing as needed
          />
                <span className={styles.logoText}>BUILD START</span>
              </div>
              <Badge variant="secondary" className={styles.professionalBadge}>
                Professional
              </Badge>
            </div>
          </div>
          <ModernNavbarPureCSS UserName={username} prefix={''} TabActiveId={'home'}  />
        </div>
      </header>

      <div className={`${styles.container} ${styles.mainContent}`}> {/* Assuming container handles mx-auto */}
        <div className={styles.welcomeSection}>
          <h1 className={styles.welcomeTitle}>Welcome back, {getFirstName(username)}! 👷‍♂️</h1>
          <p className={styles.welcomeSubtitle}>Here's what's happening with your business today</p>
        </div>

        <div className={styles.quickSearchCardWrapper}>
          <SearchFormComponent />
        </div>

        {/* Stats Cards */}
        <div className={styles.statsGrid}>
          <Card className={`${styles.statCard} ${styles.statCardBlue}`}>
            <CardContent className={styles.statCardContent}>
              <div className={styles.statCardInfo}>
                <div>
                  <p className={styles.statLabelBlue}>New Job Leads</p>
                  <p className={styles.statValue}>{businessProfile?.statistics?.jobLeadsReceived ?? '0'}</p>
                </div>
                <Eye className={styles.statIconBlue} />
              </div>
            </CardContent>
          </Card>

          <Card className={`${styles.statCard} ${styles.statCardAmber}`}>
            <CardContent className={styles.statCardContent}>
              <div className={styles.statCardInfo}>
                <div>
                  <p className={styles.statLabelAmber}>Jobs Quoted</p>
                  <p className={styles.statValue}>{businessProfile?.statistics?.quotesSent ?? '0'}</p>
                </div>
                <MessageSquare className={styles.statIconAmber} />
              </div>
            </CardContent>
          </Card>

          <Card className={`${styles.statCard} ${styles.statCardGreen}`}>
            <CardContent className={styles.statCardContent}>
              <div className={styles.statCardInfo}>
                <div>
                  <p className={styles.statLabelGreen}>Jobs Completed</p>
                  <p className={styles.statValue}>{businessProfile?.statistics?.jobsCompleted ?? '0'}</p>
                </div>
                <DollarSign className={styles.statIconGreen} />
              </div>
            </CardContent>
          </Card>

          <Card className={`${styles.statCard} ${styles.statCardPurple}`}>
            <CardContent className={styles.statCardContent}>
              <div className={styles.statCardInfo}>
                <div>
                  <p className={styles.statLabelPurple}>Profile Views</p>
                  <p className={styles.statValue}>{businessProfile?.statistics?.profileViews ?? '0'}</p>
                </div>
                <TrendingUp className={styles.statIconPurple} />
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Main Content */}
        <div className={styles.mainLayoutGrid}>
          {/* Left Column */}
          <div className={`${styles.leftColumn} ${styles.spaceY6}`}>
            {/* Recent Job Leads */}
            <Card className={styles.cardBase}>
              <CardHeader>
                <div className={styles.jobLeadsHeader}>
                  <CardTitle className={styles.cardTitleContainer}>
                    <Search className={`${styles.cardTitleIcon} ${styles.cardTitleIconBlue}`} />
                    <span>Latest Job Leads</span>
                  </CardTitle>
                  <NavLink to="/business-jobs-dashboard">
                    <Button variant="outline" size="sm" className={styles.viewAllButtonSmall}>
                      View All
                    </Button>
                  </NavLink>
                </div>
              </CardHeader>



<CardContent>
                {isLoadingJobLeads && <p>Loading job leads...</p>}
                {jobLeadsError && <p className={styles.jobItem_errorText}>Error: {jobLeadsError}</p>}
                {!isLoadingJobLeads && !jobLeadsError && jobLeads.length === 0 && (
                  <p>No job leads found.</p>
                )}
                {!isLoadingJobLeads && !jobLeadsError && jobLeads.length > 0 && (
                  <div className={styles.spaceY4}>
                    {jobLeads.slice(0, 3).map((job) => (
                      <div
                        key={job.job_id}
                        className={styles.jobLeadItem}
                      >
                        <div className={styles.jobLeadContent}>
                          <div className={styles.jobLeadTitleContainer}>
                            <h4 className={styles.jobLeadTitle}>{job.name}</h4>
                            {isUrgent(job.deadline) && (
                              <Badge variant="destructive" className={styles.jobLeadUrgentBadge}>
                                Urgent
                              </Badge>
                            )}
                          </div>

                          {/* --- THIS IS THE NEW BADGE --- */}
                          {/* Checks if the job is assigned to the CURRENT business */}
                          {job.assignedBusinessId == businessUserId && (
                              <div className={styles.assignedBadge}>
                                  <User className={styles.assignedBadgeIcon} size={14} />
                                  <span>Assigned to you</span>
                              </div>
                          )}
                          
                          <p className={styles.jobLeadLocation}>{job.postcode}</p>
                          <div className={styles.jobItem_detailsGrid}>
                            {job.profession && job.profession.length > 0 && (
                              <div>
                                <p className={styles.jobItem_detailLabel}>Professions:</p>
                                <div className={styles.jobItem_badgeContainer}>
                                  {job.profession.map(p => (
                                    <Badge key={p.professionId} className={`${styles.jobItem_badge} ${styles.jobItem_badgeOutline}`}>
                                      {p.name}
                                    </Badge>
                                  ))}
                                </div>
                              </div>
                            )}
                            <div>
                                <p className={styles.jobItem_detailLabel}>Posted:</p>
                                <p className={styles.jobItem_detailValue}>{job.created_at ? new Date(job.created_at).toLocaleDateString() : "N/A"}</p>
                            </div>
                          </div>
                        </div>
                        <div className={styles.jobLeadMeta}>
                          <p className={styles.jobLeadBudget}>{job.budgetAmount ? `$${job.budgetAmount}` : (job.budget || "N/A")}</p>
                          <Button
                            variant="outline"
                            size="sm"
                            className={styles.jobItem_viewProfileButton}
                            onClick={() =>
                              navigate("/business-jobs-dashboard", {
                                state: { selectedJob: job },
                              })
                            }
                          >
                            View Details
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardContent>



            </Card>
          </div>

          {/* Right Column */}
          <div className={`${styles.rightColumn} ${styles.spaceY6}`}>

          {/* Profile Completion */}
          <Card className={styles.cardBase}>
            <CardHeader>
              <CardTitle className={styles.cardTitleContainer}>
                <Settings className={`${styles.cardTitleIcon} ${styles.cardTitleIconBlue}`} />
                <span>Profile Completion</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              {isLoadingProfile ? (
                <p>Loading profile data...</p>
              ) : businessProfile ? (
                <div className={styles.spaceY4}>
                  <div className={styles.profileChecklist}>
                    {/* Work Portfolios (FIXED) */}
                    <div className={styles.checklistItem}>
                      <div className={`${styles.checklistDot} ${businessProfile?.workPortfolio?.model?.length > 0 ? styles.dotGreen : styles.dotAmber}`}></div>
                      {businessProfile?.workPortfolio?.model?.length > 0 ? (
                        <span>Portfolio added</span>
                      ) : (
                        <a href="/business-portfolios">Please add at least one portfolio</a>
                      )}
                    </div>

                    {/* Reviews (Made Safer) */}
                    <div className={styles.checklistItem}>
                      <div className={`${styles.checklistDot} ${businessProfile?.customerReviews?.length > 0 ? styles.dotGreen : styles.dotAmber}`}></div>
                      {businessProfile?.customerReviews?.length > 0 ? (
                        <span>You have reviews</span>
                      ) : (
                        <a href="/business-jobs-dashboard">Please complete a job and ask for a review</a>
                      )}
                    </div>

                    {/* Google Rating (Made Safer) */}
                    <div className={styles.checklistItem}>
                      <div className={`${styles.checklistDot} ${businessProfile?.statistics?.googleRating ? styles.dotGreen : styles.dotAmber}`}></div>
                      {businessProfile?.statistics?.googleRating ? (
                        <span>Google Rating imported</span>
                      ) : (
                        <button className={styles.linkButton} onClick={() => setIsGoogleModalOpen(true)}>
                          Import Google Rating
                        </button>
                      )}
                    </div>

                    {/* Services (Made Safer) */}
                    <div className={styles.checklistItem}>
                      <div className={`${styles.checklistDot} ${businessProfile?.services?.length > 2 ? styles.dotGreen : styles.dotAmber}`}></div>
                      {businessProfile?.services?.length > 2 ? (
                        <span>Services are set up</span>
                      ) : (
                        <a href="#" onClick={handleEditProfile}>Add more services</a>
                      )}
                    </div>

                    {/* Profile Description (Made Safer) */}
                    <div className={styles.checklistItem}>
                      <div className={`${styles.checklistDot} ${businessProfile?.businesses?.profileDescription?.length > 100 ? styles.dotGreen : styles.dotAmber}`}></div>
                      {businessProfile?.businesses?.profileDescription?.length > 100 ? (
                        <span>Profile description is complete</span>
                      ) : (
                        <a href="#" onClick={handleEditProfile}>Profile description is too short</a>
                      )}
                    </div>
                  </div>
                  <Button variant="outline" size="sm" className={styles.viewAllSavedButton} onClick={handleEditProfile}>
                    Edit Profile
                  </Button>
                </div>
              ) : (
                <p>Could not load profile data.</p>
              )}
            </CardContent>
          </Card>


            {/* Recent Messages */}
            <Card className={styles.cardBase}>
                <CardHeader>
                    <div className={styles.messagesHeader}>
                        <CardTitle className={styles.cardTitleContainer}>
                            <MessageSquare className={`${styles.cardTitleIcon} ${styles.cardTitleIconBlue}`} />
                            <span>Recent Messages</span>
                        </CardTitle>
                        {/* Optional: Calculate unread count dynamically */}
                        {recentMessages.filter(m => m.isRead).length > 0 && (
                            <Badge variant="secondary" className={styles.unreadBadge}>
                                {recentMessages.filter(m => m.isRead).length} unread
                            </Badge>
                        )}
                    </div>
                </CardHeader>

                {/* --- REPLACE THE CARDCONTENT WITH THIS --- */}
                <CardContent>
                    {isLoadingMessages && <p>Loading messages...</p>}
                    {messagesError && <p className={styles.jobItem_errorText}>{messagesError}</p>}
                    
                    {!isLoadingMessages && !messagesError && recentMessages.length === 0 && (
                        <div className={styles.emptyState}>
                            <MessageSquare size={32} className={styles.emptyStateIcon} />
                            <p className={styles.emptyStateText}>Your recent conversations will appear here.</p>
                        </div>
                    )}

                    {!isLoadingMessages && !messagesError && recentMessages.length > 0 && (
                        <div className={styles.messagesList}>
                            {recentMessages.map((message) => (
                                <div
                                    key={message.conversationId}
                                    className={`${styles.messageItem} ${message.isRead ? styles.messageItemUnread : styles.messageItemRead}`}
                                    onClick={() => navigate(`/business_messages?conversationId=${message.conversationId}`)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className={styles.messageMeta}>
                                        <span className={styles.messageClient}>{message.otherPartyName}</span>
                                        <span className={styles.messageTime}>{timeSince(message.lastMessageTimestamp)}</span>
                                    </div>
                                    <p className={styles.messagePreview}>{message.lastMessageSnippet}</p>
                                </div>
                            ))}
                        </div>
                    )}
                    <Button 
                        variant="outline" 
                        size="sm" 
                        className={styles.viewAllSavedButton}
                        onClick={() => navigate('/business_messages')} // Navigate to the main messages page
                    >
                        View All Messages
                    </Button>
                </CardContent>
            </Card>



            <Card className={styles.cardBase}>
              <CardHeader>
                <CardTitle className={styles.cardTitleContainer}>
                  <Heart className={`${styles.cardTitleIcon} ${styles.cardTitleIconBlue}`} />
                  <span>Saved Businesses</span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                {isLoadingSavedBusinesses && <p>Loading saved businesses...</p>}
                {!isLoadingSavedBusinesses && savedBusinessesError && (
                  <p className={styles.jobItem_errorText}>Error: {savedBusinessesError}</p>
                )}
                {!isLoadingSavedBusinesses && !savedBusinessesError && savedBusinessesData.length === 0 && (
                  <p>No saved businesses found.</p>
                )}
                {!isLoadingSavedBusinesses && !savedBusinessesError && savedBusinessesData.length > 0 && (
                  <div className={styles.spaceY4}>
                    {savedBusinessesData.map((business) => (
                      <div
                        key={business.businessId}
                        className={styles.savedBusinessItem}
                      >
                        <Avatar className={styles.savedBusinessAvatar}>
                          <AvatarImage src={business.profilePic || "/placeholder.svg"} />
                        </Avatar>
                        <div className={styles.savedBusinessInfo}>
                          <h4 className={styles.savedBusinessName}>{business.businessName}</h4>
                          {business.description && (
                            <p className={styles.savedBusinessDescription}>{business.description}</p>
                          )}
                          <div className={styles.ratingContainer}>
                            <Star className={styles.ratingStarIcon} />
                            <span className={styles.ratingValue}>
                              {business.overallRating !== null ? business.overallRating.toFixed(1) : 'N/A'}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <Button
                  variant="outline"
                  size="sm"
                  className={styles.viewAllSavedButton}
                  onClick={() => navigate('/saved-businesses')}
                >
                  View All Saved
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>


      {/* --- 5. RENDER THE MODAL COMPONENT --- */}
      <ImportGoogleRatingModal
          isOpen={isGoogleModalOpen}
          onClose={() => setIsGoogleModalOpen(false)}
          onImportSuccess={handleImportSuccess}
          businessId={loggedInBusinessId}
      />


    </div>
  );
};

export default BusinessDashboardPureCSS;
